var map = {
	"./Features-Block-Reviews-DA-DK-D.avif": 62953,
	"./Features-Block-Reviews-DE-DE-D.avif": 61243,
	"./Features-Block-Reviews-EN-GB-D.avif": 71273,
	"./Features-Block-Reviews-EN-US-D.avif": 38236,
	"./Features-Block-Reviews-ES-ES-D.avif": 48621,
	"./Features-Block-Reviews-ES-MX-D.avif": 34232,
	"./Features-Block-Reviews-FR-FR-D.avif": 82085,
	"./Features-Block-Reviews-IT-IT-D.avif": 72947,
	"./Features-Block-Reviews-NB-NO-D.avif": 41090,
	"./Features-Block-Reviews-NL-NL-D.avif": 5817,
	"./Features-Block-Reviews-PL-PL-D.avif": 62401,
	"./Features-Block-Reviews-PT-BR-D.avif": 32453,
	"./Features-Block-Reviews-PT-PT-D.avif": 9425,
	"./Features-Block-Reviews-SV-SE-D.avif": 17986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;